import ApiCommon from "api/ApiCommon"

export interface ParkingSessionResultType {
	date: string;
	grz: string;
	sessionID: string;
	paidTo: string;
}

export type ParkingSessionType = {
	result: ParkingSessionResultType[];
}

export type ParkingSessionPhotoType = {
	result: string
}

export type ParkingSessionCostType = {
	result: {
		filter(): unknown
		cost: number,
		totaldiscount?: number,
		freetime?: number,
		timeout: string, // 2022-12-21T17:22:59
		timein: string, //2022-12-21T17:22:59
		reason?: string,
		intervals?: ParkingSessionCostIntervalType[] | string,
		specialmessage?: {
			text?: string,
			type?: string,
		}
	}
}

export type ParkingSessionCostIntervalType = {
	name: string;
	cost: number;
	description: string;
}

export enum PaymentType {
	'grz' = 'grz',
	'phone' = 'phone',
	'subscription' = 'subscription',
}

export function getParkingSession(zone: string | undefined, typeID: PaymentType, valueID: string | undefined): Promise<ParkingSessionType> {
	return ApiCommon.get(`/sessions?typeID=${typeID}&valueID=${valueID}`, zone)
}

export function getParkingSessionByCamera(zone: string | undefined, cameraID: string | undefined): Promise<ParkingSessionType> {
	const params = new URLSearchParams();
	params.append('typeID', 'camera');
	params.append('valueID', cameraID ?? '');
	return ApiCommon.get(`/sessions?${params.toString()}`, zone)
}

export function getParkingSessionPhoto(zone: string | undefined, sessionID: any): Promise<ParkingSessionPhotoType> {
	return ApiCommon.get(`/foto?sessionID=${sessionID}`, zone)
}

// TODO выпилить
export function getParkingSessionCost(zone: string | undefined, sessionID: any): Promise<ParkingSessionCostType> {
	return ApiCommon.get(`/cost?sessionID=${sessionID}`, zone)
}
